<template>
	<iframe id="ifr" @load="onIframeLoad" :class="{full:fullscreen}" ref="iframe" :height="minIframeHeight" :src="src" frameborder="0"></iframe>
</template>

<script>
	export default {
		name: "message-iframe",
		props: {
			origins: {type: Array, required: false, default: () => []},
			src: {type: String, required: true},
			fullscreen: {type: Boolean, default: false}
		},
		components: {},
		data() {
			return {
				iframe: null,
				width: 800,
				height: 500
			};
		},
		computed: {
			isMobile() {
				return (window.innerWidth < this.width);
			},
			minIframeWidth() {
				return (window.innerWidth < this.width) ? window.innerWidth : this.width;
			},
			minIframeHeight() {
				return 500;
			},
		},
		methods: {
			onIframeLoad() {

				// let iframe = this.$refs.iframe.contentWindow;
				this.$emit("load");
				this.postMessage("welcome", "hello");

			},
			receiveMessage(event) {
				console.log(event);
				this.$emit("message", event.data);

			},
			postMessage(action, data) {
				this.$refs.iframe.contentWindow.postMessage({
					action,
					data
				}, "*");
			},
			postMessageCustom(custom) {
				console.log(custom, "222222");
				this.$refs.iframe.contentWindow.postMessage(custom, "*");
			}

		},
		beforeDestroy() {
			window.removeEventListener("message", this.receiveMessage, false);
		},
		created() {
			window.addEventListener("message", this.receiveMessage, false);
		}
	};
</script>

<style scoped>
	iframe {
		display: block; /* iframes are inline by default */
		border: none; /* Reset default border */
		width: 100%;
	}

	.full {
		height: 100vh;
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		z-index: 10000;
	}

	/*@media screen and (max-width: 769px) {*/
	/*	!* STYLES HERE *!*/
	/*	.full {*/
	/*		position: fixed;*/
	/*		top: 0;*/
	/*		right: 0;*/
	/*		left: 0;*/
	/*		height: 100%;*/
	/*		width: 100%;*/
	/*	}*/
	/*}*/
</style>
